<template>
  <g
    id="ic_course_flower"
    transform="translate(48 -22)"
  >
    <path
      id="Pfad_1026"
      data-name="Pfad 1026"
      d="M0,0H24V24H0Z"
      transform="translate(-48 22)"
      fill="none"
      opacity="0.87"
    />
    <g
      id="Gruppe_890"
      data-name="Gruppe 890"
      transform="translate(-46 24)"
    >
      <path
        id="Pfad_1134"
        data-name="Pfad 1134"
        d="M8.491,11.973A11.721,11.721,0,0,0,5.02,10.39,11.721,11.721,0,0,1,8.491,11.973ZM18.748,10.39A11.526,11.526,0,0,0,15.238,12,11.526,11.526,0,0,1,18.748,10.39Z"
        transform="translate(-2.05 -2.139)"
      />
      <path
        id="Pfad_1135"
        data-name="Pfad 1135"
        d="M8.862,12.133h0c-.128-.089-.266-.167-.393-.256C8.6,11.976,8.734,12.044,8.862,12.133ZM13.2,8.524A9.5,9.5,0,0,0,11.921,5.2a10.039,10.039,0,0,0-1.347,3.334,15.306,15.306,0,0,1,1.308.954A12.942,12.942,0,0,1,13.2,8.524Zm3.137,5,.01.02c-.089.059-.177.118-.266.167l-.069.049a10.02,10.02,0,0,0-2.488,2.616l-1.652,2.5-1.642-2.508a10.2,10.2,0,0,0-2.468-2.606l-.069-.039c-.128-.079-.256-.157-.384-.246l.01-.01A9.52,9.52,0,0,0,4.25,12.153a9.982,9.982,0,0,0,6.343,7.228,9.185,9.185,0,0,0,1.259.354,8.922,8.922,0,0,0,1.308-.364,9.984,9.984,0,0,0,6.323-7.218,9.261,9.261,0,0,0-3.147,1.367ZM8.911,12.162"
        transform="translate(-2.037 -2.053)"
        fill="#eda3b0"
      />
      <path
        id="Pfad_1136"
        data-name="Pfad 1136"
        d="M11.834,15.227A11.909,11.909,0,0,0,8.825,12.08c-.128-.089-.266-.157-.393-.256.128.089.266.167.384.246A11.582,11.582,0,0,0,2,9.867a11.972,11.972,0,0,0,7.9,11.3,10.571,10.571,0,0,0,1.937.5,12.725,12.725,0,0,0,1.937-.5,11.972,11.972,0,0,0,7.9-11.3A11.747,11.747,0,0,0,11.834,15.227Zm1.3,4.081a12.294,12.294,0,0,1-1.308.364,8.809,8.809,0,0,1-1.259-.354A9.982,9.982,0,0,1,4.222,12.09,9.938,9.938,0,0,1,7.291,13.4l-.02.01a4.18,4.18,0,0,0,.384.246l.069.039A9.737,9.737,0,0,1,10.192,16.3l1.642,2.517,1.642-2.508a10.02,10.02,0,0,1,2.488-2.616l.069-.049c.089-.049.177-.108.266-.167l-.01-.02a9.827,9.827,0,0,1,3.157-1.377,9.949,9.949,0,0,1-6.313,7.228Zm2.134-9.8A11.6,11.6,0,0,0,11.893,2,11.985,11.985,0,0,0,8.4,9.5a13.637,13.637,0,0,1,3.432,2.586A14.119,14.119,0,0,1,15.266,9.5ZM11.883,5.137a9.977,9.977,0,0,1,1.278,3.324,14.134,14.134,0,0,0-1.318.964,15.9,15.9,0,0,0-1.308-.954,10.039,10.039,0,0,1,1.347-3.334Z"
        transform="translate(-2 -2)"
        fill="#c9458b"
      />
      <path
        id="Pfad_1137"
        data-name="Pfad 1137"
        d="M8.989,12.279a.215.215,0,0,1-.049-.039.01.01,0,0,1,.01.01A.136.136,0,0,0,8.989,12.279Z"
        transform="translate(-2.115 -2.17)"
        opacity="0.3"
      />
    </g>
  </g>
</template>
